export default __webpack_public_path__ + "b553821ba813f2741b14c9526491227f.png";